import { Row } from 'antd';
import { memo } from 'react';
import styled from 'styled-components';
import StaffAvatar from 'components/StaffAvatar';
import { readableTextOn } from 'utils/color-contrast';
import { getColorSet } from './helper';
import { isModeFull } from './styles';
type Props = {
  url?: string;
  name: string;
  typeColor: number;
  /** Group background. Undefined for an ungrouped staff, which keeps the plain header. */
  groupColor?: string;
};
const StaffHeader = ({ url, name, typeColor, groupColor }: Props) => {
  const colorSet = getColorSet(typeColor);
  // A grouped staff gets the group color as the header card background; the name flips to
  // whichever of ink/white stays readable on it.
  const groupStyle = groupColor ? { background: groupColor } : undefined;
  const groupTextColor = groupColor ? readableTextOn(groupColor) : undefined;

  // FULL_SCREEN giu bo cuc avatar tren / ten duoi, chi thu nho ca the header lai cho bot
  // chiem chieu cao cua bang.
  if (isModeFull.value) {
    return (
      <StaffBox className='StaffBox' align={'middle'} justify={'center'} style={{ flexDirection: 'column', gap: 0, zoom: 0.85, ...groupStyle }} $grouped={!!groupColor}>
        <StaffAvatar className='staff-avatar' name={name} avatar={url} gradIndex={typeColor} size={40} fontSize={16} style={{ zoom: 2.5 }} />
        <div className='text-overflow text-ellipsis' style={{ width: '100%' }}>
          <p className='subtext' style={{ marginTop: '6px', color: groupTextColor || colorSet?.text, fontSize: '1.6rem', fontWeight: '600' }}>{name}</p>
        </div>
      </StaffBox>
    );
  }
  return (
    <StaffBox className='StaffBox' align={'middle'} justify={'center'} style={{ gap: '10px', ...groupStyle }} wrap={false} $grouped={!!groupColor}>
      <StaffAvatar className='staff-avatar' name={name} avatar={url} gradIndex={typeColor} size={40} fontSize={16} />
      <div className='text-overflow text-ellipsis'>
        <p className='subtext ' style={{ color: groupTextColor || '#1D2129', fontSize: '1.5rem', fontWeight: '600' }}>{name}</p>
      </div>
    </StaffBox>
  );
};

export default memo(StaffHeader);

const StaffBox = styled(Row) <{ $grouped?: boolean }>`
  gap: 10px;
  .subtext {
    overflow: hidden;
    color: #1D2129;
    text-overflow: ellipsis;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%; /* 20px */
    }
    .staff-avatar {
      line-height: 30px;
      border: 1px solid #fff;
    }
  ${({ $grouped }) => $grouped ? `
    width: 100%;
    border-radius: 8px;
    padding: 6px;
  `: ''}
`;
